<template>
    <div class="resumeOther competitionExp">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>竞赛经历</h1>
                <p>{{competitionExperienceSize}}/10</p>
            </el-col>
            <el-col :span="20">
                <!--非编辑状态-->
                <div v-for="(item,index) in resumeInfo.competitionExperienceList" class="workExpList">

                    <div v-if="!resumeEditStatus" class="editBtn">
                        <!--编辑按钮-->
                        <el-button slot="reference" type="text" icon="el-icon-edit-outline"
                                   @click="edit(item)" v-has-permi="['resume:competitionExperience:edit']"></el-button>

                        <!--删除按钮-->
                        <el-popconfirm title="确认删除竞赛经历？"
                                       placement="top-start"
                                       @confirm="deleteCompetitionExperience(item.id)"
                                       icon="el-icon-info"
                                       icon-color="red"
                                       v-has-permi="['resume:competitionExperience:delete']">
                            <el-button slot="reference" type="text" icon="el-icon-delete"></el-button>
                        </el-popconfirm>
                    </div>


                    <!--编辑状态-->
                    <div v-if="editStatus.id==item.id && editStatus.status==true">
                        <div v-if="resumeEditStatus==true && competitionExperienceEditStatus==true">
                            <competition-experience-form :form="form" :resumeId="resumeInfo.id" :editStatus="editStatus" ></competition-experience-form>
                        </div>
                    </div>
                    <!--非编辑状态-->
                    <div v-else class="resumeContent">
                        <el-row>
                            <el-col :span="10">
                                <p class="wrap_class" :title="item.name"><b>{{item.name}}</b></p>
                            </el-col>
                            <el-col :span="4" style="text-align: center;">
                                <p>{{item.level}}</p>
                            </el-col>
                            <el-col :span="8">
                                <p>{{item.startTime + '~' + item.endTime}}</p>
                            </el-col>
                        </el-row>
                    </div>

                </div>

                <!--新增简历竞赛经历表单-->
                <div v-if="editStatus.status==false && resumeEditStatus==true && competitionExperienceEditStatus==true">
                    <competition-experience-form :form="form" :resumeId="resumeInfo.id" :editStatus="editStatus" @editStatus="getEditStatus"></competition-experience-form>
                </div>

                <div v-if="competitionExperienceSize<10 && editStatus.status==false && resumeEditStatus==false && competitionExperienceEditStatus==false"
                     v-has-permi="['resume:competitionExperience:add']" class="addExp">
                    <el-button @click="add()" icon="el-icon-plus">添加竞赛经历</el-button>
                </div>

            </el-col>
        </el-row>
    </div>
</template>
<script>
    import CompetitionExperienceForm from './Form/CompetitionExperienceForm.vue';
    import {deleteCompetitionExperience,mergeFile} from '@/api/resume';
    export default {
        name: 'competitionExperience',
        props: ['resumeInfo'],
        data(){
            return {
                // 表单编辑状态
                editStatus: {
                    id: 0,
                    status: false,
                },
                form: {
                    certificate: null,
                    id: null,
                    level: '',
                    name: '',
                    resumeId: '',
                    type: "泰迪杯",
                    startTime: '',
                    endTime: '',
                    dateRange: []
                },

            }
        },
        computed: {
            // 简历编辑状态
            resumeEditStatus(){
                return this.$store.state.index.resumeEditStatus;
            },
            // 简历竞赛经历编辑状态
            competitionExperienceEditStatus(){
                return this.$store.state.index.competitionExperienceEditStatus;
            },
            // 简历竞赛经历列表数量
            competitionExperienceSize(){
                return this.size();
            }
        },
        created() {

        },
        methods: {
            // 计算简历竞赛经历数量
            size(){
                var competitionExperienceSize = 0;
                for(var i in this.resumeInfo.competitionExperienceList) {
                    competitionExperienceSize++;
                }
                return competitionExperienceSize;
            },
            // 表单进入编辑状态
            edit(item){
                this.add();
                Object.assign(this.form , item);
                if (item.startTime && item.endTime) {
                    this.$set(this.form, "dateRange", [item.startTime, item.endTime]);
                }
                this.editStatus.id = item.id;
                this.editStatus.status = true;
            },
            // 简历工作经历表单切换至编辑状态
            add() {
                this.form = { certificate: null, id: null, level: '', startTime: '', endTime:'', name: '', resumeId: '', type: "泰迪杯" };
                this.$store.commit('changeResumeEditStatus', true);
                this.$store.commit('changeCompetitionExperienceEditStatus', true);
            },
            // 根据id删除工作经历
            deleteCompetitionExperience(id) {
                deleteCompetitionExperience(id).then(res => {
                    this.$store.commit('changeResumeRefreshFlag', true);
                })
            },
            getEditStatus(data) {
                this.editStatus = data;
            }

        },
        components: {
            CompetitionExperienceForm,
        },
    }
</script>
<style scoped>
    .wrap_class {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
